/** Banner shown on screens where a feature is built but the third-party sender is mocked. */
export default function MockedBanner({ children, testid = "mocked-banner" }) {
  return (
    <div
      data-testid={testid}
      className="es-card p-4 border-l-4 border-l-yellow-500 bg-yellow-50 border-yellow-200 flex items-start gap-3"
    >
      <div className="es-badge es-badge-warning mt-0.5">MOCKED</div>
      <div className="text-sm text-zinc-700 leading-relaxed">
        {children}
      </div>
    </div>
  );
}
